import { MultipleRuleBuildersProvider } from '../../common/sweep-condition-rule-builder/MultipleRuleBuildersContext';
import { RoutingPage } from '../../routing/RoutingPage';
import { GlobalRenderer } from '../global-renderer/GlobalRenderer';

export const RoutingPageWithProviders = () => {
  return (
    <GlobalRenderer>
      <MultipleRuleBuildersProvider>
        <RoutingPage />
      </MultipleRuleBuildersProvider>
    </GlobalRenderer>
  );
};
